import styled from 'styled-components';

export const AvailablePrice = styled.div`
  font-size: 10px;
  height: 12px;
  color: #7c8183;
  line-height: 1;
`;

export const Date = styled.div`
  pointer-events: none;
`;
